import React from 'react';
import PropTypes from 'prop-types';
import { Grid, DataGrid, Input } from '../../components';

const SolicitanteDestinatario = (props) => {
  if (props.requerimento.solicitante && props.requerimento.destinatario) {
    return (
      <DataGrid title="Destinação" icon="ico-route" >
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled
              label="Data de Criação do Requerimento"
              value={props.requerimento.dataAberturaRequerimento}
            />
          </Grid>
        </div>
        <div className="row">
          <Grid cols="12 12 6 6">
            <Input
              disabled
              label="Solicitante"
              value={props.requerimento.solicitante.nome}
            />
          </Grid>
          <Grid cols="12 12 6 6">
            <Input
              disabled
              label="Destinatário"
              value={props.requerimento.destinatario.nome}
            />
          </Grid>
        </div>
        {props.requerimento.destinatarioOrigem ?
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                disabled
                label="Destinatário Origem"
                value={props.requerimento.destinatarioOrigem.nome}
              />
            </Grid>
          </div>
        : '' }
      </DataGrid>
    );
  }
  return '';
};

SolicitanteDestinatario.propTypes = {
  requerimento: PropTypes.objectOf(PropTypes.object).isRequired,
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
};

export default SolicitanteDestinatario;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/SolicitanteDestinatario.jsx